/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateRestrictionCheckResponseDTO interface.
 */
export function instanceOfCreateRestrictionCheckResponseDTO(value) {
    return true;
}
export function CreateRestrictionCheckResponseDTOFromJSON(json) {
    return CreateRestrictionCheckResponseDTOFromJSONTyped(json, false);
}
export function CreateRestrictionCheckResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'checkIds': json['checkIds'] == null ? undefined : json['checkIds'],
        'asinCount': json['asinCount'] == null ? undefined : json['asinCount'],
        'chunkCount': json['chunkCount'] == null ? undefined : json['chunkCount'],
    };
}
export function CreateRestrictionCheckResponseDTOToJSON(json) {
    return CreateRestrictionCheckResponseDTOToJSONTyped(json, false);
}
export function CreateRestrictionCheckResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'checkIds': value['checkIds'],
        'asinCount': value['asinCount'],
        'chunkCount': value['chunkCount'],
    };
}
